import React from 'react';
import { SetupMasterDetail } from 'areas/shared/pages/setup';
import * as APIModules from 'modules/app/API';
import * as API from 'modules/app/API';
import * as Formatter from 'fw/components/formatter/Formatter';
import { Link } from 'fw/components/formatter/Formatter';
import * as App from 'modules/app/App';
import SponsorHistoryDetail from './SponsorHistoryDetail';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Col, Row } from 'react-bootstrap';

class SponsorHistoryTab extends React.Component {
    constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
		return {
            selectedId: null,
            sponsorHistoryId: null,
            loading: true,
			title: "",
            form: {}
        };
	}

    get = () => {
		API.Sponsor.get('/sponsorSetup/getSponsorInfo', { sponsorId: this.props.selectedId },
			{
				success: (r) => {
					this.setState((prevState, props) => ({
						loading: false,
						form: r.data,
                        title: r.data.title
					}));
				}
			});
	}

    componentDidMount() {
		if (!this.props.active)
			return;

		this.get();
	}

    loadRequest = (selectedId) => {
		return {
			sponsorId: selectedId,
		};
	}
    
    render = () => {
		if (!this.props.active)
			return null;

		const opts = {
			addPrivilege: App.hasPrivilege("AdminSponsorSetupEdit"),
			addNewTitle: 'Add New Record',
			detail: SponsorHistoryDetail,
			sortField: 'sponsorHistoryId',
			vertical: false,
			list: {
				url: APIModules.Sponsor.url('/sponsorSetup/getSponsorHistory'),
				loadRequest: this.loadRequest,
				rowKey: 'sponsorHistoryId',
                columns: [
                    { key: 'invoiceNumber', name: 'Invoice Number', width: 120, formatter: InvoiceUrlFormatter, getRowMetaData: (data) => (data), isLink: true },
                    { key: 'description', name: 'Item Description' },
                    { key: 'amount', name: 'Amount', formatter: Formatter.Currency, width: 120 },
                    { key: 'activationDate', name: 'Date Paid', formatter: Formatter.Date, width: 140 },
                    { key: 'expirationDate', name: 'Expiration Date', formatter: Formatter.Date, width: 140 }
                ],
			},
		};

		return (
			<React.Fragment>
				<ContentHeader title={`Membership History - ${this.state.form.title}`} description="These are the invoices associated with the Member" >
                </ContentHeader>
                <ContentBody>
					<Row>
                        <Col md={12}>
							<SetupMasterDetail
								{...opts}
								masterId={this.props.selectedId}
								onSaving={this.props.onSaving}
								onSave={this.props.onSave}
								onDirt={this.props.onDirt}
								onUnDirt={this.props.onUnDirt}
								onCancel={this.props.onCancel}
								onError={this.props.onError}
								onSuccess={this.props.onSuccess}
								onNotFound={this.props.onNotFound}
							/>
						</Col>
					</Row>
				</ContentBody>
			</React.Fragment>
		);
	}
}

const InvoiceUrlFormatter = (row) => {
    var url = `/admin/paypalInvoiceSetup/${row.dependentValues.paypalInvoiceId}`;
    var linkValue = {
        url: url,
        title: row.dependentValues.invoiceNumber
    };

    return <Link targetBlank={true} value={linkValue}></Link>
}

export default SponsorHistoryTab;


// WEBPACK FOOTER //
// ./src/areas/admin/sponsorSetup/sponsorHistory/SponsorHistoryTab.js